import { render, staticRenderFns } from "./DocHistory.vue?vue&type=template&id=2256897a&scoped=true"
import script from "./DocHistory.vue?vue&type=script&lang=js"
export * from "./DocHistory.vue?vue&type=script&lang=js"
import style0 from "./DocHistory.vue?vue&type=style&index=0&id=2256897a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256897a",
  null
  
)

export default component.exports